import { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import { Typography } from '@mui/material';
import { MultiFilePreview, Upload } from 'src/components/upload';
import FormProvider, { RHFAutocomplete, RHFSelect, RHFTextField } from 'src/components/hook-form';
import { postRequest } from 'src/services';
import axios, { endpoints, simpleHeader } from 'src/utils/axios';
import { handleErrorMessages } from '../../risk-register/feching';
import Iconify from 'src/components/iconify';
import { ReactSketchCanvas } from 'react-sketch-canvas';
import SignatureModal from './signature';
import { useBoolean } from 'src/hooks/use-boolean';
const EmployeesCreate = ({ open, onClose, reload, currentItem, closeform, countries }) => {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [states, setStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [files, setFiles] = useState([]);
  const [filePreview, setFilePreview] = useState([]);
  const [isFileDeleted, setIsFileDeleted] = useState(false);
  const [fileType, setFileType] = useState('');
  const openModal = useBoolean()
  const [signatureData, setSignatureData] = useState()

  const sketchCanvasRef = useRef();

  const NewUserSchema = Yup.object().shape({
    // first_name: Yup.string().required('First name is required'),
    // last_name: Yup.string().required('Last name is required'),
    // email: Yup.string().nullable(),
    // mobile: Yup.string().nullable(),
    // address1: Yup.string().nullable(),
    // address2: Yup.string().nullable(),
    // suite: Yup.string().nullable(),
    // city: Yup.string().nullable(),
    // state_id: Yup.string().nullable(),
    // zip: Yup.string().nullable(),
    // country_id: Yup.string().nullable(),
    // social_security_number: Yup.string().required('Social security number is required'),
    // signature: Yup.string().required('Signature is required'),
    // phone_country: Yup.string().nullable(),
    // union: Yup.string().required('Union is required'),
  });

  const defaultValues = useMemo(
    () => ({
      first_name: currentItem?.first_name || '',
      last_name: currentItem?.last_name || '',
      email: currentItem?.email || '',
      mobile: currentItem?.mobile || '',
      address1: currentItem?.address1 || '',
      address2: currentItem?.address2 || '',
      suite: currentItem?.suite || '',
      city: currentItem?.city || '',
      state_id: currentItem?.state_id || '',
      zip: currentItem?.zip || '',
      country_id: currentItem?.country_id || '',
      social_security_number: currentItem?.social_security_number || '',
      signature: currentItem?.signature || '',
      union: currentItem?.union || '',
    }),
    [currentItem]
  );

  useEffect(() => {
    console.log('🚀 ~ defaultValues------:', defaultValues);
    if (currentItem) {
      if (currentItem.file != null) {
        setFilePreview([{ ...currentItem.file, preview: currentItem.file.url }]);
      } else {
        setFilePreview([]);
      }
    }
  }, [defaultValues]);

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    setValue,
    getValues,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    reset(defaultValues);
  }, [currentItem, reset, defaultValues]);

  const [base64File, setBase64File] = useState('');
  const [error, setError] = useState('');

  // Convert file to Base64
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]); // Remove the 'data:image/...' part
      reader.onerror = (error) => reject(error);
    });
  };

  // Handle file change (when the user selects a file)
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        setLoading(true);
        const base64String = await convertFileToBase64(file);
        setBase64File(base64String); // Store the Base64 string
        setLoading(false);
      } catch (error) {
        setError('Error converting file');
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (open && currentItem?.country?.id) {
      fetchStates(currentItem.country.id);
      setSelectedCountry(currentItem.country);
    }
  }, [currentItem, open]);

  const fetchStates = async (countryId) => {
    try {
      const response = await axios.get(endpoints.accounting.customers.get_states(countryId), {
        headers: simpleHeader,
      });
      setStates(response.data || []);
    } catch (error) {
      console.error('Error fetching states:', error);
      enqueueSnackbar('Failed to fetch states', { variant: 'error' });
      setStates([]);
    }
  };
  const handleCountryChange = async (event, newCountry) => {
    setSelectedCountry(newCountry);
    setValue('country_id', newCountry);
    // Clear the state field on country change
    setValue('state', null);
    setStates([]);

    // Fetch states if newCountry has an id
    if (newCountry?.id) {
      await fetchStates(newCountry.id);
    }
  };

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const newFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      setFiles([...newFiles]);
    },
    [files]
  );

  useEffect(()=>{
    setSignatureData(null)
  },[fileType])

//   useEffect(() => {
//     if (fileType === 'Digital Signature' && !signatureData && !openModal.value) {
//       setFileType('');
//     }
//   }, [openModal.value]);
  useEffect(()=>{
    if(fileType === 'Digital Signature'){
        openModal.onTrue()
    }
  },[fileType])

  const handleRemoveFile = (inputFile) => {
    setIsFileDeleted(true);
    setFiles([]);
    setFilePreview([]);
  };

  const handleFileType = (e) => {
    setFileType(e.target.value);
  };

  // // Handle form submission
  // const onSubmit = handleSubmit(async (data) => {
  //     console.log('Form data submitted-----------------:', data);
  //     setLoading(true);
  //     const formData = new FormData();
  //     // console.log("🚀 ~ onSubmit ~riskhange===== :", formData)
  //     formData.append("first_name", data?.first_name || '');
  //     formData.append("last_name", data?.last_name || '');
  //     formData.append("email", data?.email || '');
  //     formData.append("mobile", data?.mobile || '');
  //     formData.append("address1", data?.address1 || '');
  //     formData.append("address2", data?.address2 || '');
  //     formData.append("suite", data?.suite || '');
  //     formData.append("city", data?.city || '');
  //     formData.append("state_id", data?.state_id || '');
  //     formData.append("zip", data?.zip || '');
  //     formData.append("country_id", data?.country_id || '');
  //     formData.append("social_security_number", data?.social_security_number || '');
  //     formData.append("union", data?.union || '');
  //     if (files.length > 0) {
  //         const file = files[0];
  //         const reader = new FileReader();
  //         reader.readAsDataURL(file); // Convert file to Base64
  //         reader.onload = function () {
  //             const base64String = reader.result.split(',')[1]; // Extract Base64 without prefix
  //             formData.append('signature', base64String);
  //         };
  //     }

  //     try {
  //         const response = await postRequest(
  //             currentItem?.id
  //                 ? `${endpoints.accounting.employee.post_list}/${currentItem.id}?_method=PUT`
  //                 : endpoints.accounting.employee.post_list,
  //             formData,
  //             true
  //         );
  //         if (response.metadata && response.metadata.success) {
  //             reset();
  //             onClose();
  //             closeform();
  //             reload();
  //             enqueueSnackbar({
  //                 variant: 'success',
  //                 message: response.metadata.message,
  //             });
  //         } else {
  //             handleErrorMessages(response?.message || 'An error occurred.');
  //         }
  //     } catch (err) {
  //         console.error('Error:', err);
  //         handleErrorMessages(err.message || 'Submission failed.');
  //     } finally {
  //         setLoading(false);
  //     }
  // });
  const onSubmit = handleSubmit(async (data) => {
    console.log('Form data submitted:', data); // Log the submitted form data
    setLoading(true); // Set loading state to true

    const formData = new FormData(); // Create a new FormData object

    // Append form fields to formData
    formData.append('first_name', data?.first_name || '');
    formData.append('last_name', data?.last_name || '');
    formData.append('email', data?.email || '');
    formData.append('mobile', data?.mobile || '');
    formData.append('address1', data?.address1 || '');
    formData.append('address2', data?.address2 || '');
    formData.append('suite', data?.suite || '');
    formData.append('city', data?.city || '');
    formData.append('state_id', data?.state_id?.id || '');
    formData.append('zip', data?.zip || '');
    formData.append('country_id', data?.country_id || '');
    formData.append('social_security_number', data?.social_security_number || '');
    formData.append('union', data?.union || '');

    if (files.length > 0) {
      const file = files[0]; // Get the first file from the uploaded files
      const reader = new FileReader();

      // Convert the file to a Base64 string with MIME type
      reader.readAsDataURL(file);

      // Wait for the file reading to complete
      await new Promise((resolve, reject) => {
        reader.onload = function () {
          try {
            const base64StringWithMimeType = reader.result; // Includes MIME type (e.g., data:image/png;base64,...)
            console.log(
              '🚀 ~ awaitnewPromise ~ base64StringWithMimeType:',
              base64StringWithMimeType
            );
            formData.append('signature', base64StringWithMimeType); // Append the Base64 string to formData
            resolve();
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = function (error) {
          reject(error);
        };
      });
    }

    if(fileType === 'Digital Signature'){
        formData.append('signature', signatureData);
    }

    try {
      // Make the API request
      const response = await postRequest(
        currentItem?.id
          ? `${endpoints.accounting.employee.post_list}/${currentItem.id}?_method=PUT`
          : endpoints.accounting.employee.post_list,
        formData,
        true
      );

      // Handle success response
      if (response.metadata && response.metadata.success) {
        reset(); // Reset the form
        setSignatureData(null)
        onClose(); // Close the form or modal
        closeform(); // Additional form-closing logic
        reload(); // Reload the page or data
        enqueueSnackbar({
          variant: 'success',
          message: response.metadata.message, // Show success message
        });
      } else {
        handleErrorMessages(response?.message || 'An error occurred.'); // Handle error messages
      }
    } catch (err) {
      console.error('Error:', err); // Log the error
      handleErrorMessages(err.message || 'Submission failed.'); // Show error message
    } finally {
      setLoading(false); // Set loading state to false
    }
  });
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
          setFileType('')
        }
      }}
      fullWidth
      maxWidth="md"
      sx={{
        borderRadius: 'none',
        padding: '60px',
        fontSize: '13px',
        fontFamily: 'arial',
      }}
      transitionDuration={{
        enter: theme.transitions.duration.shortest,
        exit: theme.transitions.duration.shortest - 80,
      }}
    >
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          }}
        >
          <span
            className="cardColor"
            style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}
          >
            &nbsp;&nbsp; Employees &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <IconButton onClick={()=>{onClose(); setFileType('')}}>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            borderRadius: '1px',
          }}
        >
          <span
            style={{
              fontSize: '18px',
              fontWeight: 'bold',
            }}
          >
            Base Information
          </span>
          <Box
            mt={2}
            rowGap={2}
            columnGap={3}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
            }}
          >
            <RHFTextField name="first_name" label="First Name" />
            <RHFTextField name="last_name" label="Last Name" />
            <RHFTextField
              type="number"
              name="social_security_number"
              label="Last 4 digits SS No."
            />
            <RHFTextField type="number" name="union" label="Union Number / Code" />
            <RHFSelect
              name="signature_type"
              label="Signature Type"
              value={fileType}
              onChange={handleFileType}
            >
              <MenuItem value="Upload File">Upload File</MenuItem>
              <MenuItem value="Digital Signature">Digital Signature</MenuItem>
            </RHFSelect>
          </Box>
          {fileType === 'Upload File' && (
            <Box
              mt={4}
              rowGap={3}
              display="grid"
              // gridTemplateColumns={{
              //     xs: 'repeat(1, 1fr)',
              // }}
              sx={{ width: '100%' }}
            >
              <Typography variant="subtitle2">Upload Signature</Typography>
              <Upload onDrop={handleDrop} onRemove={handleRemoveFile} />
            </Box>
          )}
          {fileType === 'Digital Signature' && (
            <>
            <SignatureModal open={openModal.value} onClose={()=>{openModal.onFalse()}} setFileType={setFileType} setSignatureData={setSignatureData}/>
            {signatureData && <Box>
                <img src={signatureData} style={{ width: '400px', marginTop: '10px', border: '1px solid #ddd', borderRadius: '4px' }}/>
            </Box>}
            </>
          )}

          <Box sx={{ my: 3 }}>
            <MultiFilePreview
              files={files?.length > 0 ? files : filePreview}
              onRemove={handleRemoveFile}
              setFileDeleted={setIsFileDeleted}
            />
          </Box>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              //marginTop: '35px',
            }}
          >
            <span
              style={{
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Additional Information
            </span>
            <input
              type="checkbox"
              style={{ width: '16px', height: '16px' }}
              onChange={handleCheckboxChange}
              checked={isChecked}
            />
          </div>

          {isChecked && (
            <>
              <Box
                mt={2}
                rowGap={2}
                columnGap={3}
                display="grid"
                gridTemplateColumns={{
                  xs: 'repeat(1, 1fr)',
                  sm: 'repeat(2, 1fr)',
                }}
              >
                <RHFTextField name="mobile" label="Phone Number" />
                <RHFTextField name="email" label="Email" />
                <RHFTextField name="address1" label="Address Line 1" />
                <RHFTextField name="address2" label="Address Line 2" />
                <RHFTextField name="suite" label="Suite" />
                <RHFTextField name="city" label="City" />
                <RHFAutocomplete
                  name="country_id"
                  label="Country"
                  options={countries}
                  getOptionLabel={(option) => option?.name || ''}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id || 'none'}>
                      {option.name}
                    </li>
                  )}
                  onChange={handleCountryChange}
                  value={selectedCountry}
                />
                <RHFAutocomplete
                  name="state_id"
                  label="State"
                  options={states}
                  getOptionLabel={(option) => option?.name || ''}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option?.name}
                    </li>
                  )}
                />
                <RHFTextField name="zip" label="Zip Code" />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    maginLeft: '25px',
                  }}
                >
                  <input type="checkbox" style={{ width: '16px', height: '16px' }} />
                  <span
                    style={{
                      fontSize: '12px',
                      fontWeight: 'normal',
                    }}
                  >
                    Do you agree to receive text messages regarding the Project or Job and consent
                    to access location data for completing timesheets ?
                  </span>
                </div>
              </Box>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={()=>{onClose(); setFileType('')}}>
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            className="dark-button"
            loading={isSubmitting}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};
export default EmployeesCreate;
